import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import BrandMark from './BrandMark';
import { PADIPRO, RADIUS, padiproShadowMd } from './padiproTheme';

export default function EnterpriseHeader({
  title,
  subtitle,
  right = null,
  compact = false,
  transparent = false,
}) {
  return (
    <View style={[s.wrap, transparent && s.wrapTransparent]}>
      {!transparent && <View style={s.goldBar} />}
      {!transparent && <View style={s.glowOne} />}
      {!transparent && <View style={s.glowTwo} />}

      <View style={s.row}>
        <BrandMark size={compact ? 42 : 46} light={!transparent} compact />
        <View style={{ flex: 1, minWidth: 0 }}>
          <Text style={s.title} numberOfLines={1} accessibilityRole="header">
            {title}
          </Text>
          {!!subtitle && (
            <Text style={s.subtitle} numberOfLines={2}>
              {subtitle}
            </Text>
          )}
        </View>
        {!!right && <View>{right}</View>}
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  wrap: {
    position: 'relative',
    paddingVertical: 14,
    paddingHorizontal: 16,
    paddingLeft: 20,
    borderRadius: RADIUS.xl,
    borderWidth: 1,
    borderColor: PADIPRO.primaryDark,
    backgroundColor: PADIPRO.primary,
    overflow: 'hidden',
    ...padiproShadowMd,
  },
  wrapTransparent: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    paddingHorizontal: 0,
    paddingLeft: 0,
    shadowOpacity: 0,
    elevation: 0,
  },
  goldBar: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    backgroundColor: PADIPRO.gold,
  },
  glowOne: {
    position: 'absolute',
    width: 130,
    height: 130,
    borderRadius: 65,
    backgroundColor: 'rgba(166, 124, 0, 0.16)',
    top: -50,
    right: -24,
  },
  glowTwo: {
    position: 'absolute',
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    left: 10,
    bottom: -32,
  },
  row: { flexDirection: 'row', alignItems: 'center', gap: 12 },
  title: { color: '#F8FFF8', fontWeight: '900', fontSize: 18, letterSpacing: 0.1 },
  subtitle: { color: '#CFE0D2', fontWeight: '600', marginTop: 3, fontSize: 12.5, lineHeight: 17 },
});
